import PersonaPage from "./PersonaPage";
import { questionsPersonMale } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für Papa?",
    a: "Nicht mit Datum und Beruf — mit einer Geste. Wie er die Werkzeuge zurücklegte. Wie er sonntags in der Küche stand. Ein Satz, den er zu oft gesagt hat. Von dort aus schreibt sich die Rede fast von selbst.",
  },
  {
    q: "Darf ich Papa in der Rede „Papa“ nennen — oder muss es „Vater“ sein?",
    a: "Sie dürfen ihn nennen, wie Sie ihn genannt haben. „Papa“ trifft in der Regel den Ton nahe, was er für Sie war — das ist eine Rede, keine Todesanzeige.",
  },
  {
    q: "Mein Papa war ein stiller Mann. Wie soll ich lange sprechen?",
    a: "Sie müssen es nicht. Bei stillen Vätern trägt oft eine einzige Geste eine ganze Rede. Wir helfen, diesen einen Moment zu finden und ihn behutsam auszuformulieren.",
  },
  {
    q: "Wir hatten kein einfaches Verhältnis. Wie ehrlich darf ich sein?",
    a: "So ehrlich, dass Sie es aussprechen können. Eine Rede darf Distanz benennen — sie muss nur einen Punkt finden, an dem Respekt und Erinnerung zusammenfallen. Wir formulieren das behutsam.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für die Mama", to: "/trauerrede-mama" },
  { label: "Trauerrede für den Vater (formeller)", to: "/trauerrede-vater" },
  { label: "Trauerrede für den Opa", to: "/trauerrede-opa" },
];

export default function TrauerredePapa() {
  return (
    <PersonaPage
      slug="trauerrede-papa"
      metaTitle="Trauerrede für Papa schreiben — nah, warm, würdevoll | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für Ihren Papa. Aus acht behutsamen Fragen entsteht ein warmer, würdevoller Entwurf — auch für stille Väter. Ab 29 €."
      eyebrow="Trauerrede · Papa"
      headline={
        <>
          Eine Trauerrede für Papa.
          <br />
          <span className="italic text-umber">Nah. Klar. In seiner Stimme.</span>
        </>
      }
      intro={`„Papa“ ist kein formeller Name. Er trägt Kindheit, Werkzeug, Sonntagsritual, die eine Stimme am Küchentisch. Eine Trauerrede für ihn darf genau so klingen — nicht offizieller, als er war.`}
      heroImage="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1920&q=80"
      heroImageAlt="Arbeitende Männerhände im warmen Nachmittagslicht — Sinnbild einer Trauerrede für Papa"
      questions={questionsPersonMale}
      exampleQuote={
        <>
          „Papa hatte diese Art, sich am Küchentisch zurückzulehnen und für einen Moment nichts zu sagen.
          Wir haben früh gelernt: In dieser Pause war die eigentliche Antwort. Kein Vortrag. Kein
          Ratschlag. Nur ein kurzer, klarer Satz danach, den man ein Leben lang mitnimmt. Ich nehme ihn mit.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
